import React from "react";
import "./EditMenu.scss";
import { Button, Upload } from "antd";
import { ButtonLoading } from "../loading/Loading";
import { UploadOutlined } from "@ant-design/icons";
const EditMenu = ({
  formData,
  handleChange,
  handleImageChange,
  handleSubmit,
  errorMessage,
  isLoading,
  closePopup,
}) => {
  const uploadButton = (
    <Button icon={<UploadOutlined />}>Click to Upload</Button>
  );
  const uploadProps = {
    name: "image",

    className: "avatar-uploader",
    showUploadList: false,
    beforeUpload: (file) => {
      handleImageChange({ target: { files: [file] } });
      return false;
    },
  };

  return (
    <div className="frame-edit-form-overlay">
      <div className="frame-edit-form">
        <form onSubmit={handleSubmit} className="form-input">
          <div className="frame-input-edit">
            <div className="frame-input-label">
              <label htmlFor="idTrimItem">Id</label>
              <input
                type="number"
                name="idTrimItem"
                id="idTrimItem"
                value={formData.idTrimItem}
                onChange={handleChange}
                placeholder="ID"
              />
            </div>
            <div className="frame-input-label">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
              />
            </div>
            <div className="frame-input-label">
              <label htmlFor="price">Price</label>
              <input
                type="number"
                name="price"
                id="price"
                value={formData.price}
                onChange={handleChange}
                placeholder="Price"
              />
            </div>
            <div className="frame-input-loader">
              <Upload {...uploadProps}>{uploadButton}</Upload>
            </div>
          </div>

          <div>
            {formData.image && (
              <img
                src={formData.image}
                alt="Preview"
                className="image-preview"
              />
            )}

            <div className="frame-error-message">
              <p>{errorMessage}</p>
            </div>

            <div className="frame-button-save-cancel">
              <button
                type="submit"
                className="primary"
                disabled={
                  formData.idTrimItem === "" ||
                  formData.name === "" ||
                  formData.price === "" ||
                  formData.image === ""
                }
              >
                {isLoading ? <ButtonLoading /> : "Save"}
              </button>
              <button type="button" onClick={closePopup} className="cancel">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditMenu;
